import styles from '../styles/Footer.module.css';

const Footer = () => {
  return (
    <div className={styles.footer}>
      <p>
        <a href="https://vk.com/itmomegabattle">Группа сообщества</a>
      </p>
</div>
  );
};

export default Footer;
